<template>
  <div
    class="feedback-buttons"
    :style="{'width': `${modalWidth}px`}"
    :class="feedbackButtonsCustomClass"
  >
    <div
      v-for="(feedback, feedbackIndex) in allFeedbackButtonTexts"
      :key="feedbackIndex"
      :style="{'padding-left': feedbackIndex < 1 ? `${scrollingPaddingLeft}px` : ''}"
    >
      <aha-button
        @click="handleFeedbackQuiz(feedback)"
        variant="base"
        class="w-max"
        :class="{'mr-2': feedbackIndex < 4}"
        :disabled="!isDoneGenerating"
        v-aha-emit-action="{ user_input: feedback }"
        name="ai_feedback_button"
      >
        {{ $i18nPresenter.t(feedback) }}
      </aha-button>
    </div>
  </div>
</template>

<script>
import Utils from '@/util'
import { isSafariOriOS } from '@/utils/dom.utils'

export default {
  props: {
    isDocToQuizModal: {
      type: Boolean,
      default: false,
    },
    allFeedbackButtonTexts: {
      type: Array,
      default: () => [],
    },
    isDoneGenerating: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      modalWidth: null,
      scrollingPaddingLeft: 0,
    }
  },
  computed: {
    feedbackButtonsCustomClass() {
      return this.isDocToQuizModal ? 'w-max' : 'w-full'
    },
  },
  mounted() {
    this.setWidthAndScrollingPaddingLeft()
  },
  methods: {
    async setWidthAndScrollingPaddingLeft() {
      if (this.scrollingPaddingLeft || !this.isDocToQuizModal) return
      await Utils.sleep(400)
      const el = document.getElementById('doc-to-quiz__header') || document.getElementById('ai-result__header')
      this.modalWidth = el ? el.offsetWidth : 0

      const minimumPadding = 535
      const calculatedPadding = minimumPadding - this.modalWidth
      this.scrollingPaddingLeft = isSafariOriOS() ? 12 : Math.max(calculatedPadding, 0)
    },
    handleFeedbackQuiz(feedback) {
      this.$emit('handleFeedbackQuiz', feedback)
    },
  },
}
</script>

<style lang="scss" scoped>
.feedback-buttons {
  @apply absolute bottom-0 left-0 bg-base-0 rounded-b overflow-x-auto;
  @apply flex justify-center;
  z-index: 10;
  padding: 0.75rem 0.6rem;
  @media (max-width: 798px) {
    font-size: 12px;
  }
}
.feedback-button {
  @apply w-max;
}
</style>
